import type { MouseEvent } from "react";

/**
 * Double-clicking a row opens its dialog. The browser's own response to a
 * double-click — selecting the word under the pointer — is cleared first, so
 * the dialog doesn't open over a stray highlight in the list.
 */
export function rowOpenProps(open: () => void) {
    return {
        onDoubleClick: () => {
            window.getSelection()?.removeAllRanges();
            open();
        },
    };
}

/**
 * For the cell holding a row's action menu: double-clicking the menu button
 * (or an item in its dropdown, which React bubbles through the portal) must
 * not also open the row's dialog.
 */
export const stopRowOpen = {
    onDoubleClick: (e: MouseEvent) => e.stopPropagation(),
};

/**
 * Badges in table cells. Mantine truncates a badge label to fit its cell, and
 * the table sizes columns from that truncatable minimum — so "In Bearbeitung"
 * came out as "IN BE…" with room to spare elsewhere in the row. A label that
 * may not shrink makes the column take the badge's full width instead.
 */
export const cellBadgeStyles = { root: { flexShrink: 0 }, label: { overflow: "visible" } } as const;

/** Codes like EVT-2026-008 must stay on one line; a hyphen is a break point. */
export const nowrap = { whiteSpace: "nowrap" } as const;
